import React, { useContext, useEffect,Fragment, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { NavLink, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import Tune from '@material-ui/icons/Tune';
import { DatePicker, MuiPickersUtilsProvider,KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import format from "date-fns/format";
import Badge from '@material-ui/core/Badge';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faQuestionCircle, faCloud, faUserCircle, faSignOutAlt, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { clearCookie, setCookie } from '../../functions/Auth';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import '../../scss/components/_header.scss';

import MapContext from '../../context/MapContext';

import MyProfile from '../UserManagement/MyProfile';
import { isLogin, getPrivileges } from '../../functions/Auth';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";

import '../../scss/components/_header.scss';
import { MoreHorizRounded } from '@material-ui/icons';
import UserManagement from '../UserManagement/UserManagement';
import DataManagement from '../DataManagement/DataManagement';

import StationManagement from '../DataManagement/StationManagement';
import FileSharing from '../FileSharing/FileSharing';
import DataSharing  from '../DataManagement/DataSharing'; 
import moment from 'moment'
import Notification from './Notification';
const queryString = require('query-string');
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const drawerWidth = 240;

let prevStartDate = null;
let prevEndDate = null;

//Start Header component code ....
export default function Header(props) { 
  
  let history = useHistory();
  const [checked, setChecked] = React.useState(false);
  const [checkedlog, setCheckedLog] = React.useState(false);
 

  //filter states
  const [spacing, setSpacing] = React.useState(2);
  const [showBtn, setShowBtn] = React.useState(0);
  const [diffDate, setDiffDate] = React.useState(false);
  const [filterValue, setFilterValue] = React.useState(
    { volume_count: null },
    { vehicle_class: null },
    { traffic_speed: null },
    { turning_count: null },
    { pedestrian_count: null },
    { bicycle_count: null }
  );

  const [volume_count, setVolume_Count] = React.useState(false);
  const [traffic_speed, setTraffic_Speed] = React.useState(false);
  const [turning_count, setTurning_Count] = React.useState(false);
  const [pedestrian_count, setPedestrian_Count] = React.useState(false);
  const [bicycle_count, setBicycle_Count] = React.useState(false);
  const [vehicle_class, setVehicle_Class] = React.useState(false);

  const [newLoader, setNewLoader] = React.useState(false);
  const [dataError, setDataError] = React.useState(false);

  const [getSelectedStartDate, setSelectedStartDate] = React.useState(new Date());
  const [getSelectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const [invalidDate, setInvalidDate] = React.useState(false);

  const [selectedType, setSelectedType] = React.useState([]);
  const [showMidblock, setShowMidblock] = React.useState(false);
  const [showIntersection, setShowIntersection] = React.useState(false);
  const [showDates, setShowDates] = useState(false);
  const [showDatesMd, setShowDatesMd] = useState(false);
  const [showStorageFile, setShowStorageFile] = useState(false);
  const [storageTerms, setStorageTerms] = useState([{ value: '' }]);
  const [storageMatchOperator, setStorageMatchOperator] = useState('and');
  const [storageFromDate, setStorageFromDate] = useState(null);
  const [storageToDate, setStorageToDate] = useState(null);
  const [isOpenStorageFrom, setIsOpenStorageFrom] = useState(false);
  const [isOpenStorageTo, setIsOpenStorageTo] = useState(false);
  
  const [startDatePicker, setStartDatePicker] = React.useState(null);
  const [endDatePicker, setEndDatePicker] = React.useState(null);
  const [isOpenTo, setIsOpenTo] = React.useState(false);
  const [isOpenFrom, setIsOpenFrom] = React.useState(false);

  const [showMoreFilters, setShowMoreFilters] = useState(false);

  const {clearFilterYear,clearFilterMid,clearFilterInt,clearStorageFileFilter,filterisactive,updateFilterisactive,filter,updateMainFilter,clearMainFilter,updateMainFilterstart,updateMainFilterend, updateMainFilterByIntersectionType, setFilter,getSearchEnabled,setSearchEnabled,searchEnabled,midAndIntFiltersIsHidden,setHiddenMidAndIntFilters,setMidAndIntAndDateFilters,suggestStartActive,setActiveSuggestStart}=useContext(MapContext)
 
  const [userCount, setUserCount] = React.useState(0);
  const [newUserNotification, setNewUserNotification] = React.useState([]);
  const [usersInvitationLogin, setUsersInvitationLogin] = React.useState([]);
  const [checkProfile, setCheckProfile] = React.useState(false);
  const [username, setUsername] = React.useState(null);
  
  const [showNotification, setShowNotification] = React.useState(false);

  const [openUserManagement, setOpenUserManagement] = useState(false);
  const [openStationManagement, setOpenStationManagement] = useState(false);
  const [openDataManagement, setOpenDataManagement] = useState(false);
  const [openFileSharing, setOpenFileSharing] = useState(false);

  const [headerDetails, setHeaderDetails] = useState(false);

  //data sharing modal
  const [openSharedDataMd, setOpenSharedDataMd] = React.useState(false);    
  const handleCloseSharedDataMd = () => setOpenSharedDataMd(false);
  const [agenciesDataSharing, setAgenciesDataSharing] = React.useState([]); 
  const [myAgencyIsShared, setMyAgencyIsShared] = React.useState(false);       
  const openDataSharing = async () =>{
    setChecked(false);    
    let agencies = await getAgenciesToDataSharing();
    let is_sharing = await checkIfAgencyIsSharing();
    setMyAgencyIsShared(is_sharing.is_sharing)
    setAgenciesDataSharing(agencies);
    setOpenSharedDataMd(true);
  }
  const updateAgenciesToDataSharing = async () =>{
    let agencies = await getAgenciesToDataSharing();
    setAgenciesDataSharing(agencies);
  }
  const getAgenciesToDataSharing = () =>{
    try {
      return axios({
        method: 'post',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.agenciesList,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            return response.data.data.rows;
          }
        }).catch(function (error) {
          console.log(error)
          return [];
        })
    } catch (error) {
      console.error(error);
      return [];
    }      
  }
  const checkIfAgencyIsSharing = () =>{
    try {
      return axios({
        method: 'post',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.agencyIsSharing,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            return response.data.data;
          }
        }).catch(function (error) {
          console.log(error)
          return {is_sharing:false}
        })
    } catch (error) {
      console.error(error);
      return {is_sharing:false}
    }      
  }
  //
  class LocalizedUtils extends DateFnsUtils {
    getDatePickerHeaderText(date) {
      return format(date, "YYYY-MM-DD");
    }
  }

  useEffect(() => {
    getInitialDates();
    if (getPrivileges().includes(1)) {
      getNewUserCount();
      getNewUserInvitationLoginCount();
    }
    if(Cookies.get('firstName') ) {
      let tmpusername = Cookies.get('firstName').charAt(0) + Cookies.get('lastName').charAt(0);
      setUsername(tmpusername);
    }
    
    let intersection_details = window.location.pathname.search("intersection_details");
    let midblock_details = window.location.pathname.search("midblock_details");
    let help_page = window.location.pathname.search("help");
    let file_import = window.location.pathname.search("file-import-requirements-and-best-practices");
    let privacy = window.location.pathname.search("privacy_policy");
    let isInDetails = (intersection_details != -1 || midblock_details != -1 || help_page !== -1 || file_import !== -1 || privacy !== -1);
    setHeaderDetails(isInDetails);
  
  }, [Cookies.get('firstName'), Cookies.get('lastName')]);
  
  useEffect(() => {
    if(searchEnabled){
      doClearFilterYear()
    }
    }, [searchEnabled]);

  useEffect(() => {
  }, [newUserNotification, usersInvitationLogin]);

  useEffect(()=>{
    if (suggestStartActive){
      doClearFilterYear();
      setActiveSuggestStart(false);
    }
  }, [suggestStartActive]);

  let email = sessionStorage.getItem('email');
  let token = sessionStorage.getItem('jwtToken')

  //This method is use for show new user notification ..... start  
  const getNewUserCount = () => {
    try {
      axios({
        method: 'get',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getUserNotification,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setUserCount(response.data.data.count)
            setNewUserNotification(response.data.data.result);
          }
        }).catch(function (error) {
          console.log(error)
        })
    } catch (error) {
      console.error(error);
    }
  }

  const getNewUserInvitationLoginCount = () => {
    try {
      axios({
        method: 'get',
        headers: {
          'payload': Cookies.get('payload'),
          'email': Cookies.get('email'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getUserInvitationLoginNotification,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setUsersInvitationLogin(response.data.data.result);
          }
        }).catch(function (error) {
          console.log(error)
        })
    } catch (error) {
      console.error(error);
    }
  }

  //This method is use for show new user notification ..... end

  //This method is use for show update new user notification ..... start  
  const updateNewUserCount = () => {
    let users = [];
    for (let i = 0; i < newUserNotification.length; i++)
      users.push({user_id: newUserNotification[i].user_id, field: 'isRead'});
    setNewUserNotification([]);
    for (let i = 0; i < usersInvitationLogin.length; i++)
      users.push({user_id: usersInvitationLogin[i].user_id, field: 'firts_date_login_isRead'});
    setUsersInvitationLogin([]);
    try {
      axios({
        method: 'post',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        data:{users : users},
        url: API_URL + API_PATH.updateUserNotificationv2,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setUserCount([]);
            setShowNotification(false);
            // history.push('/users_management');
            setOpenUserManagement(true);
            setChecked(false);
          }
        }).catch(function (error) {
          console.log(error);
          // history.push('/users_management');
          setOpenUserManagement(true);
          setChecked(false);
        })
    } catch (error) {
      console.error(error);
      // history.push('/users_management');
      setOpenUserManagement(true);
      setChecked(false);
    }
  }
  //This method is use for show update new user notification ..... end
 
  //
  const showStationManagement=()=>{
    setOpenStationManagement(true);
    setChecked(false);
  }
  //


  //This method is use for show dismiss new user notification ..... start  
  const dismissNewUserCount = (user_id, field) => {    
    try {
      axios({
        method: 'post',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        data:{users : [{user_id:user_id, field:field}]},
        url: API_URL + API_PATH.updateUserNotificationv2,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            //setUserCount(response.data.data.count);
            //setShowNotification(true);
            if (field === 'isRead'){
              setUserCount(userCount-1)
              setNewUserNotification((items) => newUserNotification.filter(item => item.user_id !== user_id));
            }
            else 
              setUsersInvitationLogin((items) => usersInvitationLogin.filter(item => item.user_id !== user_id));
            setChecked(false);
          }
        }).catch(function (error) {
          console.log(error);
          
          setChecked(false);
        })
    } catch (error) {
      console.error(error);
      
      setChecked(false);
    }
  }
 //This method is use for show dismiss new user notification ..... start  
  const handleMenu = () => {

    setChecked((prev) => !prev);
  };

  const handleClickAway = () => {
    setChecked(false);
  };


  const handleLogout = () => {
    setCheckedLog((prev) => !prev);
  };

  const showMyProfile = () => {
    setCheckProfile((prev) => !prev);
    setCheckedLog(false);
  }
  const userMenu = () => {
    setCheckedLog(false);
  }
  const hideMyProfile = () => {
    setCheckProfile(false);
  }

  const signOutUser = () => {
    if (Cookies.get('email')) {
      try {
        axios({
          method: 'post',
          data: { 'email': Cookies.get('email') },
          url: API_URL + API_PATH.signOutAPI,
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              clearCookies();
              history.push("/");
            }
          })
          .catch(function (error) {
            clearCookies();
            history.push("/");
          })
      } catch (error) {
        clearCookies();
        history.push("/");
      }
    } else {
      history.push("/");
    }
  }
 //This method is use for get initial dates .... Start

 const clearCookies = () => {
  clearCookie('email');
  clearCookie('payload');
  clearCookie('idToken');
  clearCookie('organization');
  clearCookie('atexpiry');
  clearCookie('firstName');
  clearCookie('lastName');
  clearCookie('alLogIn');
  clearCookie('stationDetailsMap');
  clearCookie('activeSearchFilter');
  clearCookie('activeSearchStation');
  sessionStorage.removeItem('activeSearchResult');
  clearCookie('activeSearchText');
  clearCookie('polygonExtent');
  clearCookie('externalLayers');
  clearCookie('geolayer');
}


 const getInitialDates = () => {
  if (!prevStartDate &&
    !prevEndDate) {
    let date = new Date();
    let endDate = new Date();
    let currentDate = new Date(date.getFullYear(), date.getMonth(), 1);
    setSelectedEndDate(endDate);
    let startyear = currentDate.getFullYear() - 5;
    currentDate.setFullYear(startyear);
    setSelectedStartDate(date);
   
    
   // console.log("endDate",datePickerVal.getFullYear())
  } else {
    setSelectedEndDate(prevEndDate);
    setSelectedStartDate(prevStartDate);
  }
}

  
   //This method is use for change start date .... Start
   const handleStartDateChange = (e) => {
    setIsOpenTo(false)
    let date = new Date(e.getFullYear(), e.getMonth(), 1);
    setSelectedStartDate(date);
    setStartDatePicker(date);
    prevStartDate = date;
    prevEndDate = getSelectedEndDate;
    updateMainFilter('startDate',e.getFullYear()+"-"+((parseInt(e.getMonth() + 1)<10?'0'+parseInt(e.getMonth() + 1):parseInt(e.getMonth() + 1)))+"-01")
    updateFilterisactive(true)
    setMidAndIntAndDateFilters(true);

  }
  //This method is use for change start date .... End

  //This method is use for change end date .... Start
  const handleEndDateChange = (e) => {
    setIsOpenFrom(false)
    let currentMonth = new Date();
    let date = null;
    let datePickerVal = e;
    if (e.getMonth() !== (currentMonth.getMonth())) {
      date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth() + 1, 0);
    } else {
      if ((currentMonth.getFullYear() == datePickerVal.getFullYear())) {
        date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth(), currentMonth.getDate());
      } else {
        date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth() + 1, 0);
      }
    }
    setSelectedEndDate(date);
    setEndDatePicker(date);
   
    prevEndDate = date;
    prevStartDate = getSelectedStartDate;
    
    updateFilterisactive(true)
    var _endDate = moment(datePickerVal).add(1,'months').format("YYYY-MM-01");
        
    updateMainFilterend('endDate',_endDate)

  }
  //This method is use for change end date .... End
  
  //This method is use for volume Count .... Start
  const volumeCount = (event) => {
    let volCount = volume_count;
    updateFilterisactive(true)
    updateMainFilter('volume',event.target.checked)
  }
  //This method is use for get volume Count .... End

  //This method is use for vehicle Class .... Start
  const vehicleClass = (event) => {
    let vehiClass = vehicle_class;
    updateFilterisactive(true)
    updateMainFilter('class',event.target.checked)
  }
  //This method is use for vehicle Class .... End

  //This method is use for traffic Speed .... Start
  const trafficSpeed = (event) => {
    let traffSpeed = traffic_speed;
    updateFilterisactive(true)
    updateMainFilter('speed',event.target.checked)
  }
  //This method is use for traffic Speed .... end
 
  //This method is use for get turning Count data.... start
  const turningCount = (event) => {
    let turnCount = turning_count;
    updateFilterisactive(true)
    updateMainFilter('turn',event.target.checked)
  }
  //This method is use for get turning Count data.... end

  //This method is use for get pedestrian Count data .... start
  const pedestrianCount = (event) => {
    let pedesCount = pedestrian_count;
    updateFilterisactive(true)
    updateMainFilter('pedestrian',event.target.checked)
  }
  //This method is use for get pedestrian Count data .... End

  //This method is use for get Bicycle Count data .... Start
  const bicycleCount = (event) => {
    let bicycCount = bicycle_count;
    updateFilterisactive(true)
    updateMainFilter('bicycle',event.target.checked)
  }
  //This method is use for get Bicycle Count data .... End

 
  //This method is use for get Bicycle Count data .... End

  //This method is use for show stations .... Start
  const ShowStations = () => {
    
    setDataError(false)
    let startDate = getSelectedStartDate.getFullYear() + '-' + (parseInt(getSelectedStartDate.getMonth()) + 1 > 9 ? parseInt(getSelectedStartDate.getMonth()) + 1 : ('0' + (parseInt(getSelectedStartDate.getMonth()) + 1))) + '-' + (parseInt(getSelectedStartDate.getDate()) > 9 ? parseInt(getSelectedStartDate.getDate()) : ('0' + (parseInt(getSelectedStartDate.getDate()))));

    let endDate = getSelectedEndDate.getFullYear() + '-' + (parseInt(getSelectedEndDate.getMonth()) + 1 > 9 ? parseInt(getSelectedEndDate.getMonth()) + 1 : '0' + (parseInt(getSelectedEndDate.getMonth()) + 1)) + '-' + (parseInt(getSelectedEndDate.getDate()) > 9 ? parseInt(getSelectedEndDate.getDate()) : ('0' + (parseInt(getSelectedEndDate.getDate()))));

    let currentMonth = parseInt(getSelectedStartDate.getMonth()) + 1 > 9 ? parseInt(getSelectedStartDate.getMonth()) + 1 : '0' + (parseInt(getSelectedStartDate.getMonth()) + 1);

    let endMonth = parseInt(getSelectedEndDate.getMonth()) + 1 > 9 ? parseInt(getSelectedEndDate.getMonth()) + 1 : '0' + (parseInt(getSelectedEndDate.getMonth()) + 1);

    let startYear = getSelectedStartDate.getFullYear();
    let endYear = getSelectedEndDate.getFullYear();

    if (startDate === endDate) {
      setDiffDate(true);
      setInvalidDate(false);
      return false;
    } else if ((currentMonth > endMonth && startYear > endYear) || startDate > endDate || startYear > endYear) {
      setDiffDate(false);
      setInvalidDate(true);
      return false;
    } else {
      setInvalidDate(false);
      setDiffDate(false);
    }

    
    let filterParams = {
      volume_count: volume_count,
      class_count: vehicle_class,
      speed_count: traffic_speed,
      turning_count: turning_count,
      pedestrian_count: pedestrian_count,
      bicycle_count: bicycle_count,
      //selected_type: '{b}',
      selected_type: '{' + selectedType.toString() + '}',
      startDate: startDate,
      endDate: endDate
    };

    

   /* if(!Cookies.get('payload')) {
      clearCookie('activeSearchText');
      sessionStorage.removeItem('activeSearchResult');
      setCookie('activeSearchFilter', filterParams);
    }
*/

    props.callFilter(filterParams)

    //props.loaderFunction();
    
  }


  const handleTypeSign = (event, type) => {
    updateFilterisactive(true);
    updateMainFilterByIntersectionType(type, event.target.checked)
  }

  //This method is use for show stations .... Start
  const runFilter = (stationType) => {
    

    //props.loaderFunction();
    ShowStations()
  }


  //This method is use for show stations .... End
  const doClearFilterYear = () => {   

    let currentDate = new Date()
    setEndDatePicker(null)
    setStartDatePicker(null)
    setSelectedEndDate(currentDate.getFullYear());
    clearFilterYear()
    // doClearFilterInt()
    // doClearFilterMid()
    setFilter({...filter,
      startDate:"",
      endDate:"",
      volume:false,
      class:false,
      speed:false,
      turn:false,
      pedestrian:false,
      bicycle:false,
      intersection_type: {
        signal: false,
        stop: false,
        roundabout: false,
        unknown: false,
      }
    })
    setShowIntersection(false);
    setShowMidblock(false);
    setMidAndIntAndDateFilters(false);
    setTimeout(() => updateFilterisactive(false), 1000);
    //
    
  }
  const doClearFilterInt = () => {  
    setShowIntersection(false);
    clearFilterInt()
  }

  
  const doClearFilterMid = () => {    
    setShowMidblock(false);
                         
    clearFilterMid()
    setTimeout(() => {
      
      if(!filter.class && !filter.volume && !filter.speed && !filter.turn && !filter.pedestrian && !filter.bicycle && !Object.values(filter.intersection_type).filter(item => item === true).length > 0){
       
        updateFilterisactive(false)
        //
        }
      

    }, 1000);
    

  }


  const showfilterPanelMid=()=>{
    setShowIntersection(false);
    setShowMidblock((showMidblock) => !showMidblock);
   
    
  }
  const showfilterPanelInt=()=>{
    setShowMidblock(false);
    setShowIntersection((showIntersection) => !showIntersection);
  }
  const [selectedDate, handleDateChange] = useState(new Date());
  const openNotification=()=>{
    setShowNotification(!showNotification)
    console.log("open notification")
  }
  const viewUser=()=>{

  }
  const dismissUser=()=>{
    
  }

  const handleShowMoreFilters = () => {
    setShowMoreFilters(!showMoreFilters);
  }

  const handleClickAwayFilters = () => {
    setShowMoreFilters(false);
    setShowDatesMd(false);
  }

  const handleClickAwayFilters2 = () => {
    setShowDates(false);
  }

  const handleOpenDataManager = () => {
    setChecked(false);
    setOpenDataManagement(true);
  }

  const handleOpenFileSharing = () => {
    setChecked(false);
    setOpenFileSharing(true);
  }

  const goToHelp = () => {
    setCheckedLog(false);
    history.push('/help');
  }

  const showfilterDates=(size)=>{
    if(size === "lg"){
      setShowDates(!showDates);
      setShowDatesMd(false);
    }
    else if(size === "md") {
      setShowDatesMd(showDatesMd => !showDatesMd);
      setShowDates(false);
    }
  }

  const handleStorageTermChange = (idx, value) => {
    setStorageTerms(storageTerms.map((t, i) => i === idx ? { ...t, value } : t));
  };

  const addStorageTerm = () => {
    setStorageTerms([...storageTerms, { value: '' }]);
  };

  const removeStorageTerm = (idx) => {
    setStorageTerms(storageTerms.filter((_, i) => i !== idx));
  };

  const handleStorageSearch = () => {
    const activeTerms = storageTerms.map(t => t.value.trim()).filter(Boolean);
    setFilter(prev => ({
      ...prev,
      storageFileTerms: activeTerms,
      storageFileOperator: storageMatchOperator.toUpperCase(),
      storageFileFilterActive: activeTerms.length > 0 || !!storageFromDate || !!storageToDate,
      storageFileFromDate: storageFromDate,
      storageFileToDate: storageToDate,
    }));
    setShowStorageFile(false);
  };

  const clearStorageFileSearch = () => {
    setStorageTerms([{ value: '' }]);
    setStorageMatchOperator('and');
    setStorageFromDate(null);
    setStorageToDate(null);
    if (clearStorageFileFilter) clearStorageFileFilter();
  };

  const handleClickAwayStorageFile = () => {
    setShowStorageFile(false);
  };

  return (
    <React.Fragment>
      <div className="header">
        <div className="root">
          <CssBaseline />
          <AppBar position="relative">
            <Toolbar className="toolbar padding-0">
            <div className="unauthenticated-state">
              {!headerDetails?<NavLink to={`/`} style={{ textDecoration: 'none',display:'flex'}} >
                <img src={require('../../assets/images/dataPointLogo.svg')} className="header-icon" />
              </NavLink>:<a href='/' style={{display:'flex',position:'relative',left:'50%',marginLeft:'-68px',top: '5px'}}>
                <img src={require('../../assets/images/dataPointLogo.svg')} className="header-icon" />
                </a>}
              {(!headerDetails)?
                <>
                <div className="mapView__search" >
                    <div    className="searchIcon">                    
                    <SearchIcon/>
                    </div>
                    {/*<InputBase placeholder="Search anything"/>*/}
                    <div id="search-conainer-v2"></div>                
                </div>
                    {
                      !midAndIntFiltersIsHidden ? (
                        <>
                          <Button className={((filter.class || filter.volume || filter.speed) ? "mid-filter-selected " : "") + "mapView__btn-gray-filter btn-h-1 sm-screen"} variant="outlined" onClick={showfilterPanelMid} style={{ width: '140px' }}>
                            <img src={require('../../assets/icons/map_pin_mid.svg')} width="24px" />
                            Midblock
                            <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" />
                          </Button>
                          <Button className={((filter.turn || filter.pedestrian || filter.bicycle || Object.values(filter.intersection_type).filter(item => item === true).length > 0) ? "mid-filter-selected " : "") + "mapView__btn-gray-filter btn-h-1 sm-screen"}
                            variant="outlined" onClick={showfilterPanelInt} style={{ width: '159px' }}>
                            <img src={require('../../assets/icons/map_pin_int.svg')} width="24px" />
                            Intersection
                            <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" />
                          </Button>
                          </>
                          ) : null
                    }
                          <Button className={((filter.endDate!== "" || filter.startDate !== "") ? "date-filter-selected " : "") + "mapView__btn-gray-filter btn-h-1-date sm-screen md-screen"}
                            variant="outlined" onClick={() => showfilterDates("lg")}>
                            <img src={require('../../assets/icons/calendar-gold.svg')} width="20px" />
                            Dates
                            <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" />
                          </Button>                        
                {/* Storage Files search trigger + dropdown — wrapped in relative container so dropdown aligns below */}
                <div className="sm-screen" style={{ position: 'relative' }}>
                  <Button
                    className={"storage-file-search-trigger" + (filter.storageFileFilterActive ? " active" : "") + (showStorageFile ? " open" : "")}
                    onClick={() => { setShowStorageFile(!showStorageFile); setShowDates(false); setShowDatesMd(false); setShowMidblock(false); setShowIntersection(false); }}
                    disableRipple
                  >
                    <SearchIcon className="trigger-search-icon" />
                    <span className="trigger-placeholder">Search storage files</span>
                    <Tune className="trigger-tune-icon" />
                  </Button>

                  {showStorageFile && (
                  <ClickAwayListener onClickAway={handleClickAwayStorageFile}>
                    <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1300, paddingTop: '5px' }}>
                      <Collapse in={showStorageFile}>
                        <Paper elevation={4} style={{
                          display: 'block',
                          padding: '16px',
                          width: '290px',
                          borderRadius: '6px',
                          boxSizing: 'border-box',
                          boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1), 0px 4px 6px -2px rgba(0,0,0,0.05)',
                        }}>

                          {/* By date */}
                          <p style={{ margin: '0 0 10px 0', fontSize: '14px', fontFamily: 'Inter-Medium', color: '#374151', fontWeight: 500 }}>By date</p>
                          {/* From row — picker + arrow */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <MuiPickersUtilsProvider utils={LocalizedUtils}>
                              <KeyboardDatePicker
                                autoOk clearable variant="inline"
                                InputProps={{ readOnly: true }}
                                label={storageFromDate ? '' : 'From'}
                                value={storageFromDate}
                                inputVariant="outlined"
                                format="MMM yyyy" openTo="year" views={["year","month"]}
                                invalidLabel="" invalidDateMessage="" emptyLabel=""
                                maxDate={new Date()}
                                InputAdornmentProps={{ position: "end" }}
                                open={isOpenStorageFrom}
                                onOpen={() => setIsOpenStorageFrom(true)}
                                onClose={() => setIsOpenStorageFrom(false)}
                                onClick={() => setIsOpenStorageFrom(true)}
                                onChange={date => {
                                  setStorageFromDate(date);
                                  setIsOpenStorageFrom(false);
                                  // Clear To if it's before the new From
                                  if (storageToDate && date && storageToDate < date) {
                                    setStorageToDate(null);
                                  }
                                }}
                                style={{ flex: 1 }}
                                className={storageFromDate ? 'date-picker' : 'date-picker-null'}
                                keyboardIcon={storageFromDate
                                  ? <img src={require('../../assets/icons/calendar-blue.png')} alt="" />
                                  : <img src={require('../../assets/icons/calendar.png')} alt="" />}
                              />
                            </MuiPickersUtilsProvider>
                            <span style={{ color: '#9CA3AF', fontSize: '16px', flexShrink: 0, width: '16px', textAlign: 'center' }}>→</span>
                          </div>
                          {/* To row — same flex layout with invisible spacer so widths match */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <MuiPickersUtilsProvider utils={LocalizedUtils}>
                              <KeyboardDatePicker
                                autoOk clearable variant="inline"
                                InputProps={{ readOnly: true }}
                                label={storageToDate ? '' : 'To'}
                                value={storageToDate}
                                inputVariant="outlined"
                                format="MMM yyyy" openTo="year" views={["year","month"]}
                                invalidLabel="" invalidDateMessage="" emptyLabel=""
                                maxDate={new Date()}
                                minDate={storageFromDate || new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                                InputAdornmentProps={{ position: "end" }}
                                open={isOpenStorageTo}
                                onOpen={() => setIsOpenStorageTo(true)}
                                onClose={() => setIsOpenStorageTo(false)}
                                onClick={() => setIsOpenStorageTo(true)}
                                onChange={date => {
                                  setStorageToDate(date);
                                  setIsOpenStorageTo(false);
                                }}
                                style={{ flex: 1 }}
                                className={storageToDate ? 'date-picker' : 'date-picker-null-to'}
                                keyboardIcon={storageToDate
                                  ? <img src={require('../../assets/icons/calendar-blue.png')} alt="" />
                                  : <img src={require('../../assets/icons/calendar.png')} alt="" />}
                              />
                            </MuiPickersUtilsProvider>
                            {/* Invisible spacer — keeps To picker same width as From picker */}
                            <span style={{ flexShrink: 0, width: '16px' }} />
                          </div>

                          {/* Advanced search */}
                          <p style={{ margin: '16px 0 10px 0', fontSize: '14px', fontFamily: 'Inter-Medium', color: '#374151', fontWeight: 500 }}>Advanced search</p>

                          {/* Match operator row — no gap between buttons, both bordered */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                            <span style={{ fontSize: '14px', color: '#6B7280', flexShrink: 0 }}>Match</span>
                            <div style={{ display: 'flex' }}>
                              <Button
                                size="small"
                                onClick={() => setStorageMatchOperator('and')}
                                style={{
                                  minWidth: '52px', height: '34px', fontSize: '14px',
                                  textTransform: 'none', fontFamily: 'Inter-Regular',
                                  border: `1px solid ${storageMatchOperator === 'and' ? '#2563EB' : '#D1D5DB'}`,
                                  color: storageMatchOperator === 'and' ? '#2563EB' : '#374151',
                                  borderRadius: '6px 0 0 6px', padding: '0 12px',
                                  zIndex: storageMatchOperator === 'and' ? 1 : 0,
                                }}
                              >and</Button>
                              <Button
                                size="small"
                                onClick={() => setStorageMatchOperator('or')}
                                style={{
                                  minWidth: '44px', height: '34px', fontSize: '14px',
                                  textTransform: 'none', fontFamily: 'Inter-Regular',
                                  border: `1px solid ${storageMatchOperator === 'or' ? '#2563EB' : '#D1D5DB'}`,
                                  color: storageMatchOperator === 'or' ? '#2563EB' : '#374151',
                                  borderRadius: '0 6px 6px 0', padding: '0 12px',
                                  marginLeft: '-1px',
                                  zIndex: storageMatchOperator === 'or' ? 1 : 0,
                                }}
                              >or</Button>
                            </div>
                          </div>

                          {/* Term input rows */}
                          {storageTerms.map((term, idx) => (
                            <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                              <TextField
                                placeholder="filename, keyword, or .extension"
                                variant="outlined" size="small"
                                value={term.value}
                                onChange={e => handleStorageTermChange(idx, e.target.value)}
                                style={{ flex: 1 }}
                              />
                              {idx === storageTerms.length - 1 ? (
                                <Button
                                  size="small"
                                  onClick={addStorageTerm}
                                  style={{
                                    minWidth: '36px', width: '36px', height: '36px', padding: 0,
                                    fontSize: '20px', lineHeight: 1, border: '1px solid #D1D5DB',
                                    color: '#374151', borderRadius: '6px', flexShrink: 0,
                                  }}
                                >+</Button>
                              ) : (
                                <Button
                                  size="small"
                                  onClick={() => removeStorageTerm(idx)}
                                  style={{
                                    minWidth: '36px', width: '36px', height: '36px', padding: 0,
                                    fontSize: '18px', lineHeight: 1, border: '1px solid #D1D5DB',
                                    color: '#374151', borderRadius: '6px', flexShrink: 0,
                                  }}
                                >×</Button>
                              )}
                            </div>
                          ))}

                          {/* Action buttons */}
                          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                            <Button
                              variant="contained"
                              onClick={handleStorageSearch}
                              style={{
                                flex: 1, height: '40px', backgroundColor: '#2563EB', color: '#ffffff',
                                fontFamily: 'Inter-Medium', fontSize: '14px', textTransform: 'none',
                                borderRadius: '6px', boxShadow: 'none', minWidth: 0,
                              }}
                            >Search</Button>
                            <Button
                              variant="outlined"
                              onClick={clearStorageFileSearch}
                              style={{
                                flex: 1, height: '40px', backgroundColor: '#EFF6FF', color: '#2563EB',
                                borderColor: '#BFDBFE', fontFamily: 'Inter-Medium', fontSize: '14px',
                                textTransform: 'none', borderRadius: '6px', minWidth: 0,
                                whiteSpace: 'nowrap',
                              }}
                            >Clear filters</Button>
                          </div>

                        </Paper>
                      </Collapse>
                    </div>
                  </ClickAwayListener>
                  )}
                </div>

                {(showDates) &&
                <div className="dates-filters-list sm-screen md-screen" style={{left : !midAndIntFiltersIsHidden ? '687px' : '415px'}}>
                  <ClickAwayListener onClickAway={() => handleClickAwayFilters2()}>
                    <Collapse in={showDates}>
                      <Paper elevation={4} className="paper">
                        <MuiPickersUtilsProvider utils={LocalizedUtils}>
                          <KeyboardDatePicker
                            autoOk
                            allowSameDateSelection={true}
                            clearable
                            variant="inline"
                            InputProps={{ readOnly: true }}
                            label={(filter.startDate !== "") ?'':'From'}
                            value={filter.startDate !== "" ? startDatePicker : null}
                            inputVariant="outlined"
                            allowKeyboardControl='false'
                            format='MMM yyyy'
                            openTo="year"
                            views={["year", "month",]}
                            invalidLabel=""
                            invalidDateMessage=""
                            emptyLabel=""
                            maxDate={new Date()}
                            minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                            InputAdornmentProps={{ position: "end" }}
                            onChange={handleStartDateChange}
                            onClick={()=>{
                              setIsOpenTo(false);
                              setIsOpenFrom(true);
                              setShowMidblock(false);
                              setShowIntersection(false);
                            }}
                            onMonthChange={()=>{setIsOpenFrom(false)}}
                            className={(filter.startDate !== "") ?'date-picker':'date-picker-null'}
                            keyboardIcon={(filter.startDate !== "") ?<img src={require('../../assets/icons/calendar-blue.png')}/>:<img src={require('../../assets/icons/calendar.png')}/>}
                              
                          />
                          </MuiPickersUtilsProvider>
                            <img src={require('../../assets/icons/filter_dates_arrow.png')} />
                          <MuiPickersUtilsProvider utils={LocalizedUtils}>
                            <KeyboardDatePicker
                            autoOk
                            InputProps={{ readOnly: true }}
                              label={(filter.endDate !== "") ?'':'To'}
                              value={ filter.endDate !== "" ? endDatePicker : null}
                              variant="inline"
                              inputVariant="outlined"
                              format='MMM yyyy'
                              openTo="year"
                              views={["year", "month",]}
                              display= "grid"
                              invalidLabel=""
                              invalidDateMessage=""
                              emptyLabel=""
                              maxDate={new Date()}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                              renderInput={(params) => <TextField {...params} />}
                              onChange={handleEndDateChange}
                              onClick={()=>{setIsOpenFrom(false);
                                setIsOpenTo(true);
                                setShowMidblock(false);
                                setShowIntersection(false);
                              }}
                              onMonthChange={()=>{setIsOpenTo(false)}}
                              className={(filter.endDate !== "") ?'date-picker':'date-picker-null-to'}
                              keyboardIcon={(filter.endDate !== "") ?<img src={require('../../assets/icons/calendar-blue.png')} />:<img src={require('../../assets/icons/calendar.png')}/>}
                            />
                          </MuiPickersUtilsProvider>       
                      </Paper>
                    </Collapse>
                  </ClickAwayListener>
                </div>
                }
               </>:null
              }

               {/* More filters on small screens */}
               {
                (!headerDetails) &&
                <label className={ (filter.endDate !== "" || (filter.class || filter.volume || filter.speed) || (filter.turn || filter.pedestrian || filter.bicycle)) ? "more-filters show_md_screen active" : "more-filters show_md_screen" } onClick={handleShowMoreFilters}><MoreHorizRounded /></label>
               }


               {(showMoreFilters) &&
                <div className="more-fitlers-list show_md_screen">
                  <ClickAwayListener onClickAway={() => handleClickAwayFilters()}>
                    <Collapse in={showMoreFilters}>
                      <Paper elevation={4} className="paper">
                        <Button className={((filter.class || filter.volume || filter.speed) ? "mid-filter-selected " : "") + "mapView__btn-gray-filter btn-h-1 show_sm_screen"} variant="outlined" onClick={showfilterPanelMid}><img src={require('../../assets/icons/map_pin_mid.svg')} width="24px" /> Midblock  <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" /> </Button>
                        <Button className={((filter.turn || filter.pedestrian || filter.bicycle || Object.values(filter.intersection_type).filter(item => item === true).length > 0 ) ? "mid-filter-selected " : "") + "mapView__btn-gray-filter btn-h-1 show_sm_screen"} variant="outlined" onClick={showfilterPanelInt}><img src={require('../../assets/icons/map_pin_int.svg')} width="24px" /> Intersection <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" /></Button>
                        
                        <Button className={( (filter.endDate !== "" || filter.startDate !== "") ?"date-filter-selected ":"")+ "mapView__btn-gray-filter btn-h-1-date"} 
                        variant="outlined" onClick={() => showfilterDates("md")}>
                          <img src={require('../../assets/icons/calendar-gold.svg')} width="20px" />
                          Dates 
                          <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" />
                        </Button>
                      </Paper>
                      {(showDatesMd) &&
                        <div className={`dates-filters-list-md show_md_screen ${(filter.startDate !== "") ? "noNullLeft" : "nullLeft"}`}>
                          <MuiPickersUtilsProvider utils={LocalizedUtils} className="md-screen sm-screen">
                            <KeyboardDatePicker
                              autoOk
                              allowSameDateSelection={true}
                              clearable
                              variant="inline"
                              InputProps={{ readOnly: true }}
                              label={(filter.startDate !== "") ?'':'From'}
                              value={filter.startDate !== "" ? startDatePicker : null}
                              inputVariant="outlined"
                              format='MMM yyyy'
                              openTo="year"
                              views={["year", "month",]}
                              invalidLabel=""
                              invalidDateMessage=""
                              emptyLabel=""
                              maxDate={new Date()}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                              InputAdornmentProps={{ position: "end" }}
                              onChange={handleStartDateChange}
                              onClick={()=>{
                                setIsOpenTo(false);
                                setIsOpenFrom(true);
                                setShowMidblock(false);
                                setShowIntersection(false);
                              }}
                              onMonthChange={()=>{setIsOpenFrom(false)}}
                              className={(filter.startDate !== "") ?'date-picker':'date-picker-null'}
                              keyboardIcon={(filter.startDate !== "") ?<img src={require('../../assets/icons/calendar-blue.png')}/>:<img src={require('../../assets/icons/calendar.png')}/>}
                            />
                          </MuiPickersUtilsProvider>
                          <img src={require('../../assets/icons/filter_dates_arrow.png')} />
                          <MuiPickersUtilsProvider utils={LocalizedUtils} className="md-screen sm-screen">
                            <KeyboardDatePicker
                              autoOk
                              label={(filter.endDate !== "") ?'':'To'}
                              value={filter.endDate !== "" ? endDatePicker : null}
                              variant="inline"
                              InputProps={{ readOnly: true }}
                              inputVariant="outlined"
                              format='MMM yyyy'
                              openTo="year"
                              views={["year", "month",]}
                              display= "grid"
                              invalidLabel=""
                              invalidDateMessage=""
                              emptyLabel=""
                              maxDate={new Date()}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                              renderInput={(params) => <TextField {...params} />}
                              onChange={handleEndDateChange}
                              onClick={()=>{setIsOpenFrom(false);
                                setIsOpenTo(true);
                                setShowMidblock(false);
                                setShowIntersection(false);}}
                              onMonthChange={()=>{setIsOpenTo(false)}}
                              className={(filter.endDate !== "") ?'date-picker':'date-picker-null-to'}
                              keyboardIcon={(filter.endDate !== "") ?<img src={require('../../assets/icons/calendar-blue.png')} />:<img src={require('../../assets/icons/calendar.png')}/>}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      }
                    </Collapse>
                  </ClickAwayListener>
                </div>
                }

               {!headerDetails && ((filter.class || filter.volume || filter.speed || filter.turn || filter.pedestrian || filter.bicycle) || filter.endDate!=="" || filter.startDate!=="" || Object.values(filter.intersection_type).filter(item => item === true).length > 0)?
               <Button 
                  className={'clear-filter-year-btn'}
                  onClick={doClearFilterYear}
                  >
                  Clear filters 
                  </Button>
                  :null}
            </div>
              {
                isLogin() ?
                <div className="authenticated-state" style={headerDetails ? ( getPrivileges().includes(1) ? {top: '-4px'} : {top: '1px'}) : null}>
                  {
                    (getPrivileges().length === 1 && getPrivileges().includes(3)) ?
                    null :
                    getPrivileges().length !== 0 &&
                    (!headerDetails)?
                      <NavLink to={`/UsersDashboard?import=` + 1} style={{ textDecoration: 'none' }}>
                      <Button className="blue-btn font-14" variant=""><img src={require('../../assets/icons/file_add.svg')} />
                        Import
                      </Button></NavLink> 
                    :null 
                  }
                  {
                      (userCount > 0 || usersInvitationLogin.length > 0) && getPrivileges().includes(1) ?
                      (!headerDetails)?
                      <Badge  variant="dot"  onClick={()=>openNotification()} style={{cursor:'pointer'}}>
                          <img src={require('../../assets/icons/notifications.png')}  />
                      </Badge>:null
                      :
                      getPrivileges().includes(1) &&
                      (!headerDetails)?<img src={require('../../assets/icons/notifications.png')} onClick={()=>openNotification()}/>:null
                  }
                  {
                    getPrivileges().includes(1) &&
                    (!headerDetails)?<img onClick={handleMenu} src={require('../../assets/icons/admin.png')} />:null
                  }
                  
                  <div className="username" style={!getPrivileges().includes(1) ? {marginTop: '3px'}: {marginTop: '8px'}} onClick={handleLogout}>{username}</div>
                </div>
                :
                <div style={ !headerDetails ? { position: 'absolute', right: '0', display: 'flex', alignItems: 'center' } : { position: 'absolute', right: '0', display: 'flex', alignItems: 'center', top: '-4px' }}>
                    {/*<img className="public-help" onClick={goToHelp} src={require('../../assets/icons/public-help.png')} />*/}
                    <NavLink to="/sign_in" style={{ textDecoration: 'none' }} className={'txt-gray-500'}
                    >
                      <Button className="bg-gray-500   btn-h-2" variant="outlined">
                        Sign in
                      </Button>
                    </NavLink> 
                 

                    <NavLink to="/sign_up" style={{ textDecoration: 'none' }} className={'txt-gray-white'}>
                      <Button className=" btn-h-3 bg-blue-600" variant="" >
                        Sign up
                      </Button>
                    </NavLink> 

                  
                </div>
              }
            </Toolbar>
          </AppBar>
        </div>
      </div>
      {checked ?
        <div className="drop-menu" style={!getPrivileges().includes(1) && !getPrivileges().includes(2) ? { width: '125px' } : null}>
          <ClickAwayListener onClickAway={() => handleClickAway()}>
            <Collapse in={checked}>
              <Paper elevation={4} className="paper">
                {
                  getPrivileges().includes(1) &&
                  <div className="admin-menu">
                    <p><NavLink to="#" onClick={handleOpenDataManager} title="Data management"><img src={require('../../assets/icons/management_menu/data-management.svg')} /> Data management</NavLink></p>
                    <p><NavLink to="#" onClick={() => updateNewUserCount()} title="User management"><img src={require('../../assets/icons/management_menu/user-management.svg')} /> User management</NavLink></p>
                    <p><NavLink to="#" onClick={() => showStationManagement()} title="Station management"><img src={require('../../assets/icons/management_menu/station-management.svg')} /> Station management</NavLink></p>
                    <p className="divisor"></p>
                    <p><NavLink to="#" onClick={() => openDataSharing()} title="Data sharing"><img src={require('../../assets/icons/management_menu/data-sharing.svg')} /> Data sharing</NavLink></p>
                    <p><NavLink to="#" onClick={handleOpenFileSharing}  title="File access"><img src={require('../../assets/icons/management_menu/file-sharing.svg')} /> File access</NavLink></p>
                  </div>
                }
              </Paper>
            </Collapse>
          </ClickAwayListener>
        </div> : null
      }
      {checkedlog &&
        <div className="droplog">
          <ClickAwayListener onClickAway={userMenu}>
          <Collapse in={checkedlog}>
            <Paper elevation={4} className="paper">
              <div className="user-menu">
                  <p onClick={showMyProfile}><img src={require('../../assets/icons/user_menu/my-profile.svg')} /> My Profile</p>
                  {/*<p onClick={goToHelp}><img src={require('../../assets/icons/user_menu/help.svg')} /> Help</p>*/}
                  <p className="divisor"></p>
                  <p onClick={() => { signOutUser() }}><img src={require('../../assets/icons/user_menu/logout.svg')} /> Log out</p>
              </div>
            </Paper>
          </Collapse>
          </ClickAwayListener>
        </div>
      }
      {checkProfile ?
        <div className="dropProfile">
          <Collapse in={checkProfile}>
            <Paper elevation={4} className="paper">
              <MyProfile checkValue={hideMyProfile} />
            </Paper>
          </Collapse>
        </div> : null
      }
      {showMidblock?
            <ClickAwayListener onClickAway={() => setShowMidblock(false)}>
                <div className={'filter-midblock'}>
                  <FormGroup>
                    <FormControlLabel control={<><Checkbox checked={filter.volume} 
                                                onChange={volumeCount} /><img className='filter-volume-icon' src={require('../../assets/icons/volume.png')}/></>} label={"Volume count"} />
                    <FormControlLabel  control={<><Checkbox checked={filter.class} 
                                                  onChange={vehicleClass} /><img className='filter-class-icon' src={require('../../assets/icons/class.png')}/></>} label="Vehicle class" />
                    <FormControlLabel  control={<><Checkbox checked={filter.speed} 
                                                  onChange={trafficSpeed} /><img className='filter-speed-icon' src={require('../../assets/icons/speed.png')}/></>} label="Vehicle speed"/>
                  </FormGroup>
                  {( filter.volume || filter.class || filter.speed)?
                  <div className="clear-filter-container">
                    
                 
              
                  <Button 
                  className={'clear-filter-btn'}
                  onClick={doClearFilterMid}
                  >
                  Clear filters 
                  </Button>
                  </div>
                  :
                  null
                  }
                  </div>
               
            </ClickAwayListener>
        :
        null
      }
      {showIntersection?
        <ClickAwayListener onClickAway={() => setShowIntersection(false)}>
            <div className={'filter-intersection'}>
            <FormGroup>
            <label className='title-filter'><p>By count</p></label>
            <FormControlLabel control={<><Checkbox checked={filter.turn} 
                                        onChange={turningCount}/><img className='filter-turning-icon' src={require('../../assets/icons/turning.png')}/></>} label="Turning count"/>
            <FormControlLabel  control={<><Checkbox checked={filter.pedestrian} 
                                            onChange={pedestrianCount} /><img className='filter-pedestrian-icon' src={require('../../assets/icons/pedestrian.png')}/></>} label="Pedestrian count" />
            <FormControlLabel   control={<><Checkbox checked={filter.bicycle}
                                        onChange={bicycleCount}
                                        id="bicycle_count" /><img className='filter-bicycle-icon' src={require('../../assets/icons/bicycle.png')}/></>} label="Bicycle count"/>
            </FormGroup>
            <FormGroup>
              <label className='title-filter'><p>By type</p></label>
              <FormControlLabel
                control={
                  <>
                    <Checkbox checked={filter.intersection_type.signal} onChange={e => handleTypeSign(e, 'signal')} />
                      <img className='filter-turning-icon' src={require('../../assets/icons/intersection_types/signal.svg')} alt='Signal'
                    />
                  </>
                }
                label="Signal" />
                <FormControlLabel
                control={
                  <>
                    <Checkbox checked={filter.intersection_type.stop} onChange={e => handleTypeSign(e, 'stop')} />
                      <img className='filter-turning-icon' src={require('../../assets/icons/intersection_types/stop.svg')} alt='Stop'
                    />
                  </>
                }
                label="Stop" />
                <FormControlLabel
                control={
                  <>
                    <Checkbox checked={filter.intersection_type.roundabout} onChange={e => handleTypeSign(e, 'roundabout')} />
                      <img className='filter-turning-icon' src={require('../../assets/icons/intersection_types/roundabout.svg')} alt='Roundabout'
                    />
                  </>
                }
                label="Roundabout" />
                <FormControlLabel
                control={
                  <>
                    <Checkbox checked={filter.intersection_type.unknown} onChange={e => handleTypeSign(e, 'unknown')} />
                      <img className='filter-turning-icon' src={require('../../assets/icons/intersection_types/unknown.svg')} alt='Unknown'
                    />
                  </>
                }
                label="Unknown" />
            </FormGroup>
            {( filter.turn || filter.pedestrian || filter.bicycle || Object.values(filter.intersection_type).filter(item => item === true).length > 0)?
            <div className="clear-filter-container">
          
            <Button 
            className={'clear-filter-btn'}
            onClick={doClearFilterInt}
            >
            Clear filters 
            </Button>
            </div>
            :
            null
            }
            

           

            </div>
        </ClickAwayListener>
        :
        null
      }
      {
          showNotification?
        <>

        {(userCount > 0 || usersInvitationLogin.length > 0)?
              <>
                <ClickAwayListener onClickAway={() => { setShowNotification(false); }}>
                  <div className='notification-container'>
                    {
                      newUserNotification.length > 0 &&
                      newUserNotification.map(user => {
                        return <Notification user={user} field={'isRead'} title={"New user signed in"} subtitle={["A new user has recently registered into Datapoint"]} setShowNotification={setShowNotification} updateNewUserCount={updateNewUserCount} dismissNewUserCount={dismissNewUserCount} />
                      })
                    }
                    {
                      usersInvitationLogin.length > 0 ?
                        usersInvitationLogin.map(user => {
                          const date = new Date(user.firts_date_login);
                          const day = date.getDate();
                          const month = date.getMonth();
                          const year = date.getFullYear();
                          const hour = date.getHours();
                          const minute = date.getMinutes();
                          return <Notification user={user} field={'firts_date_login_isRead'} title={"Initial Logon"} subtitle={["The user you invited", `${user.first_name}`, `${user.last_name}`, "has logged into DataPoint on", `${month}`, `${day}`, `${year}`, "at", `${hour}`, `${minute}`, `${user.email}`]} setShowNotification={setShowNotification} updateNewUserCount={updateNewUserCount} dismissNewUserCount={dismissNewUserCount} />
                        }) : null
                    }
                  </div>
                </ClickAwayListener>
              </>
              :
              <> <ClickAwayListener onClickAway={() => {setShowNotification(false); }}>
                <div className={'panel-notification-no-user shadow-l'}>
                    <div className={'panel-notification-container-no-user'}>
                    
                      <div className={'panel-notification-center pn-child'}>
                        
                        <div className={"panel-n-content-no"}>
                        No new notifications at this time
                        </div>
                        
                      </div>
                      <div className={'panel-notification-right pn-child'}>
                      <img src={require('../../assets/icons/close.png')} style={{cursor:'pointer'}} onClick={()=>{ setShowNotification(false)}} />              </div>

                    </div>
                    
                  

                  </div>
                  </ClickAwayListener>
              </>}
        </>

          :null
      }

      {
        openUserManagement && 
        <UserManagement  
          setOpenUserManagement={setOpenUserManagement}
        />
      }

    {
        openStationManagement && 
        <StationManagement  
        setOpenStationManagement={setOpenStationManagement}
        />
      }

      {
        openDataManagement && 
        <DataManagement  
          setOpenDataManagement={setOpenDataManagement}
        />
      }

      {
        openFileSharing && 
        <FileSharing  
          setOpenFileSharing={setOpenFileSharing}
        />
      }

    <DataSharing
        handleCloseSharedDataMd={handleCloseSharedDataMd}
        openSharedDataMd={openSharedDataMd}
        agencies={agenciesDataSharing}
        is_shared={myAgencyIsShared}
        updateAgencies={updateAgenciesToDataSharing}
    />  
    </React.Fragment>
  );
}
//End Header component code ....